// extracted by mini-css-extract-plugin
export default {"Container":"GridCollection_Container__10Xso","TextTime":"GridCollection_TextTime__v+3Y+","PopupText":"GridCollection_PopupText__+QTGi"};